import { getIcons } from '_helpers';
import { useNavigate } from 'react-router-dom';

export {ReturnButton};

function ReturnButton({ from = '' }) {

    const navigate = useNavigate();

    return (
        <button type="submit" className="btn-custom btn-custom-primary btn-return" onClick={() => navigate(-1)}>                            
            <img src={getIcons("arrowBackIosNewOutlinedWhite")} alt="icon return" className="btn-custom-icon"/> 
            Retour
        </button>)
}